import React from 'react';
import EmbeddedVideo from '@/components/elements/embedded-video';

export default function MdxVideo({ id }) {
	return (
		<div className="mdx-video">
			<EmbeddedVideo videoId={id} videoPlatform="vimeo" />
		</div>
	);
}
